import { render, staticRenderFns } from "./ivyobject.vue?vue&type=template&id=40c7f507&scoped=true&"
import script from "./ivyobject.vue?vue&type=script&lang=js&"
export * from "./ivyobject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7f507",
  null
  
)

export default component.exports